import { render, staticRenderFns } from "./ProfileBanner.vue?vue&type=template&id=19ef3521&"
import script from "./ProfileBanner.vue?vue&type=script&lang=ts&"
export * from "./ProfileBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports